import { useTranslation } from 'react-i18next';
import { SPACES_EMPTY_STATE_MODERATOR, SPACES_EMPTY_STATE_STUDENT } from 'utils/constants';
import { isAdmin } from 'utils/userHelpers';

import React from 'react';

import { useCommunityContext } from 'components/CommunityContext';
import CreatePostCard from 'components/InfoCard/variations/CreatePostCard/CreatePostCard';

const SpaceEmptyState = () => {
  const { t } = useTranslation();
  const { currentUser } = useCommunityContext();
  const userIsAdmin = isAdmin(currentUser);

  const emptyStateTitle = userIsAdmin
    ? t('components-spaceEmptyState-moderator_title', 'First things first, say hello!')
    : t('components-spaceEmptyState-student_title', 'Come on in and say hello!');
  const emptyStateContent = userIsAdmin ? (
    <p>
      {t(
        'components-spaceEmptyState-moderator_description',
        "Your members can't wait to meet you, so jump in and introduce yourself."
      )}
      <br />
      <br />
      {t(
        'components-spaceEmptyState-moderator_description_complement',
        'You can encourage them to do the same with a few ice breaker questions.'
      )}
    </p>
  ) : (
    t(
      'components-spaceEmptyState-student_description',
      'Think of this space like a virtual room where you can sit down, get comfortable, ask questions and share ideas on specific topics with your fellow community members.'
    )
  );

  const emptyStateImageSrc = userIsAdmin
    ? SPACES_EMPTY_STATE_MODERATOR
    : SPACES_EMPTY_STATE_STUDENT;

  return (
    <CreatePostCard
      content={emptyStateContent}
      dataQA="space-empty-state"
      imageSrc={emptyStateImageSrc}
      title={emptyStateTitle}
    />
  );
};

export default SpaceEmptyState;
